import { render, staticRenderFns } from "./Clickbutton.vue?vue&type=template&id=3bb69883&scoped=true&"
import script from "./Clickbutton.vue?vue&type=script&lang=ts&"
export * from "./Clickbutton.vue?vue&type=script&lang=ts&"
import style0 from "./Clickbutton.vue?vue&type=style&index=0&id=3bb69883&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb69883",
  null
  
)

export default component.exports